<template>
    <div >
        <div class="flx jcsb" style="padding: 0.3rem;">
            <i class="el-icon-arrow-left" style="font-size: 0.6rem;" @click="goback()"></i>
            <div style="font-size: 0.4rem;" class="fwb">商家详情</div>
            <div style="width: 0.6rem;;"></div>
        </div>
        <div v-loading="loading" style="padding: 0.8rem 0.3rem;">
            <div style="font-size: 0.42rem;" class="fwb">{{a_data.name}}</div>
            <div class="rich-box" v-html="a_data.content"></div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'StoreInfo',    
    data () {
        return {
            loading: true,
            a_data: ''
        }
    },
    methods:{
        getData2() {
            var that = this;
            this.$post('index.php?s=/api/index/shangjia_info', {
                wxapp_id: 10001,
                id: this.id
            })
            .then((res) => {
                if(res.code == 1) {
                    var a_data = res.data.list;
                    if(a_data.content) {
                        a_data.content = this.showHtml(a_data.content);
                        a_data.content = a_data.content.replace(/<\/?br[^>]*>/gi,'')
                    }
                    this.a_data = a_data;
                    setTimeout(function () {
                        that.loading = false;
                    }, 600)
                }
            }) 
        },
        showHtml(str){
            return str
            .replace(str ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/&lt;/g,"<")
            .replace(/&gt;/g,">")
            .replace(/&quot;/g,"\"")
            .replace(/&#39;/g, "\"")
            .replace(/&amp;nbsp;/g,'\u3000')
        },
        goback() {
            this.$router.back();
        },
    },
    created() {
        var data = this.$route.query;
        this.id = data.id;
        this.getData2();
        document.title = '商家详情';
    },
    mounted() {

	},
}
</script>

<style scoped>
    .rich-box >>> img{
        width: 100%;
    }
    .rich-box >>> p{
        font-size: 0.3rem;
        word-wrap: break-word;
        line-height: 0.5rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/bigshot2/storeinfo2.vue